/* ==========================================================================
   On Document Load Add Class
   ========================================================================== */

window.addEventListener(
  "load",
  function () {
    document
      .querySelector<HTMLElement>("html")
      .classList.add("document-loaded");
  },
  true
);
